!<!--  -->
<template>
  <div class="" style="">
    <div
      class=""
      style="
        padding: 30px;
        background: #ffffff;
        box-shadow: rgb(107 105 105 / 21%) 0px 0px 20px 0px;
        border-radius: 10px;
      "
    >
      <span
        style="
          margin-bottom: 20px;
          width: 71px;
          height: 23px;
          font-size: 24px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #343434;
        "
        >{{$t('i18n_pick_up_party')}}</span
      >

      <div class="btnBorder">
        <span
          @click="dialogVisible = true"
          class="pointer"
          style="
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
          "
          >{{$t('i18n_new_pickup_address')}}</span
        >
      </div>
      <!-- 地址卡片 -->
      <div>
        <el-card
          v-for="(item, index) in addrList"
          :key="index"
          class="box-card card-hover"
          style="margin-bottom: 20px; border-radius: 10px"
        >
          <div
            style="
              max-height: 500px;
              display: flex;
              align-items: center;
              justify-content: space-between;
              padding-right: 40px;
            "
          >
            <div style="">
              <!-- 行1 -->
              <div>
                <span
                  style="
                    font-size: 20px;
                    font-family: PingFang SC;
                    font-weight: bold;
                    color: #343434;
                  "
                  >{{ item.name }}</span
                >
                <span
                  style="
                    margin-left: 20px;
                    font-size: 16px;
                    font-family: PingFang SC;
                    font-weight: 500;
                    color: #343434;
                  "
                  >{{ item.tel }}</span
                >
                <div class="defaultAddrDiv" v-if="item.isDefault">
                  <span>{{$t('i18n_default_address')}}</span>
                </div>
                <div class="defaultAddrDiv" v-if="item.tag">
                  <span>{{ item.tag }}</span>
                </div>
              </div>

              <!-- 行2 -->
              <div style="margin-top: 20px">
                <span style="margin-right: 10px">{{ item.country }}</span>
                <span style="margin-right: 10px">{{ item.city }}</span>
                <span style="margin-right: 10px" v-if="item.area">{{
                  item.area
                }}</span>
                <span style="margin-right: 10px">{{ item.address }}</span>
              </div>
            </div>

            <div>
              <span
                @click="setAsDefault(item)"
                v-if="!item.isDefault"
                class="pointer editBtn"
                >{{$t('i18n_set_to_default')}}</span
              >
              <span @click="edit(item)" class="pointer editBtn">{{$t('i18n_edit')}}</span>
              <span
                @click="confirmDelete(item.id)"
                style="color: #999; padding: 0 20px"
                class="pointer"
                >{{$t('i18n_delete')}}</span
              >
            </div>
          </div>
        </el-card>
      </div>

      <!-- 新增弹窗 -->
      <el-dialog
        :before-close="handleClose"
        custom-class="class1"
        style="border-radius: 20px"
        :title="$t('i18n_Create_new_address')"
        :visible.sync="dialogVisible"
        width="30%"
      >
        <div style="width: 85%; margin: 0 auto; max-width: 500px">
          <el-row :gutter="20" style="margin-bottom: 20px">
            <el-col :span="6">
              <div class="grid-content bg-purple">
                <span style="line-height: 40px">{{$t('i18n_contact_person')}}</span>
              </div>
            </el-col>
            <el-col :span="18">
              <div class="grid-content bg-purple">
                <el-input
                  v-model="submitForm.consignee"
                  :placeholder="$t('i18n_please_type_your_name')"
                ></el-input></div
            ></el-col>
          </el-row>
          <el-row :gutter="20" style="margin-bottom: 20px">
            <el-col :span="6"
              ><div class="grid-content bg-purple">
                <span style="line-height: 40px">{{$t('i18n_contact_info')}}</span>
              </div></el-col
            >
            <el-col :span="18">
              <div class="grid-content bg-purple">
                <el-input
                  v-model="submitForm.tel"
                  :placeholder="$t('i18n_please_type_the_contact_info')"
                ></el-input></div
            ></el-col>
          </el-row>
          <el-row :gutter="20" style="margin-bottom: 20px">
            <el-col :span="7"
              ><div class="grid-content bg-purple">
                <span style="line-height: 40px">{{$t('i18n_contact_address')}}</span>
              </div></el-col
            >
            <el-col :span="17">
              <div class="grid-content bg-purple">
                <el-cascader
                  :options="citylist"
                  :placeholder="$t('i18n_please_choose')"
                  v-model="value"
                  clearable
                  @change="handleChange"
                  :props="props"
                >
                </el-cascader>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="20" style="margin-bottom: 20px">
            <el-col :span="6"
              ><div class="grid-content bg-purple">
                <div
                  style="line-height: 40px; width: 10px; height: 10px"
                ></div></div
            ></el-col>
            <el-col :span="18"
              ><div class="grid-content bg-purple">
                <el-input
                  v-model="submitForm.address"
                  type="textarea"
                  rows="2"
                  :placeholder="$t('i18n_please_enter_the_detailed_location')"
                ></el-input></div
            ></el-col>
          </el-row>
          <el-row :gutter="20" style="margin-bottom: 20px">
            <el-col :span="6"
              ><div class="grid-content bg-purple">
                <span style="line-height: 40px">{{$t('i18n_label')}}</span>
              </div></el-col
            >
            <el-col :span="18"
              ><div class="grid-content bg-purple">
                <el-input
                  v-model="submitForm.label"
                  :placeholder="$t('i18n_please_enter')"
                ></el-input></div
            ></el-col>
          </el-row>

          <div style="width: 300px; margin: 0 auto; text-align: center">
            <div style="display: flex; justify-content: center">
              <el-checkbox
                text-color="#5F4AFF"
                v-model="submitForm.isdefaultaddress"
                style="margin-right: 10px"
              ></el-checkbox>
              <span style="display: block; margin-bottom: 20px">
                {{$t('i18n_set_to_default_address')}}
              </span>
            </div>
            <el-button @click="addAddr" type="primary">{{
              this.submitForm.id ? $t("i18n_edit") : $t("i18n_add")
            }}</el-button>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      props: {
        value: "namec",
        label: "namec",
      },
      value: "",
      citylist: [], // 省市区列表
      submitForm: {
        address: "",
        area: "",
        city: "",
        consignee: "",
        contactype2: "T",
        country: "",
        customerid: "",
        isdefaultaddress: false,
        label: "",
        openid: "",
        parvince: "",
        tel: "",
        type: "I",
      },
      dialogVisible: false,
      addrList: [],
      value: ["", ""],
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    handleScroll() {
      //获取滚动时的高度
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      //
      console.log(scrollTop);
      // if (scrollTop > 0) {
      //   //滚动大于0的时候要做的操作
      // }
      // if (scrollTop > 200) {
      //   //大于200的时候要做的操作
      // }
      // if (scrollTop > oneHeight) {
      //   //这是滑动到scrollTwo的距离要做的操作

      // }
      // if (scrollTop > twoHeight) {
      //   //这是滑动到scrollThree要做的操作
      // }
    },

    // 校验
    very() {
      if (!this.submitForm.consignee) {
        this.$message.info($t('i18n_contact_person_cant_be_empty'))
        return false;
      }
      if (!/^1[3456789]\d{9}$/.test(this.submitForm.tel)) {
        this.$message.info(this.$t("i18n_contact_number_incorrect"));
        return false;
      }
      // 城市
      if (!this.submitForm.city) {
        this.$message.info("联系地址不能为空！");
        return false;
      }
      // 区
      if (!this.submitForm.area) {
        this.$message.info("联系地址不能为空！");
        return false;
      }
      if (!this.submitForm.address) {
        this.$message.info("详细地址不能为空！");
        return false;
      }
      if (this.submitForm.label) {
        if (this.submitForm.label.length > 5) {
          this.$message.info(this.$t("i18n_label_cannot_exceeds_5_characters"))
          return false;
        }
      }

      return true;
    },

    setAsDefault(item) {
      this.submitForm.consignee = item.name;
      this.submitForm.country = item.country;
      this.submitForm.city = item.city;
      this.submitForm.area = item.area;
      this.submitForm.id = item.id;
      this.submitForm.tel = item.tel;
      //    this.submitForm.city = item.city
      this.submitForm.address = item.address;
      this.submitForm.label = item.tag;
      this.submitForm.isdefaultaddress = true;
      this.addAddr();
    },
    resetData() {
      for (let key in this.submitForm) {
        this.submitForm[key] = "";
      }
      this.submitForm.type = "I";
      this.submitForm.contactype2 = "T";
      this.submitForm.isdefaultaddress = false;
      console.log(this.value);

      console.log(this.value);
      this.value = ["", "", ""];
    },
    handleClose(done) {
      this.dialogVisible = false;
      this.resetData();
    },
    // 修改赋值
    edit(item) {
      console.log(item);
      //    this.submitForm.country = item.country
      // this.value = []
      this.value = ["", "", ""];
      this.value[0] = item.country;
      this.value[1] = item.city;
      this.value[2] = item.area;
      console.log(this.value);
      this.submitForm.consignee = item.name;
      this.submitForm.parvince = item.country;
      this.submitForm.area = item.area;
      this.submitForm.city = item.city;
      this.submitForm.id = item.id;
      this.submitForm.tel = item.tel;
      //    this.submitForm.city = item.city
      this.submitForm.address = item.address;
      this.submitForm.label = item.tag;
      this.submitForm.isdefaultaddress = item.isDefault;

      this.dialogVisible = true;
    },
    // 获取省市区列表
    getPopList() {
      let user = sessionStorage.getItem("Authorization");
      user = JSON.parse(user);

      this.axios
        .post(
          "filedata/filedataProvinces",
          {},
          {
            headers: {
              token: user.token,
            },
          }
        )
        .then((res) => {
          console.log(res);
          if (res.data.code == 200) {
            this.citylist = res.data.datas;
          } else {
            this.$message.info("服务器繁忙");
          }
        })
        .catch((res) => {
          this.$message.info("服务器繁忙");
        });
    },
    // 级联选择器方法
    handleChange(value) {
      console.log(value);
      this.submitForm.parvince = value[0];
      this.submitForm.city = value[1];
      this.submitForm.area = value[2];
    },
    // 删除
    confirmDelete(id) {
      this.$confirm(this.$t("i18n_delete_address_tip"), this.$t("i18n_hint"), {
        confirmButtonText: this.$t("i18n_confirm"),
        cancelButtonText: this.$t("i18n_cancel"),
        type: "warning",
      })
        .then(() => {
          let user = sessionStorage.getItem("Authorization");
          user = JSON.parse(user);

          this.axios
            .post(
              "customer/delAddress/" + id,
              {},
              {
                headers: {
                  token: user.token,
                },
              }
            )
            .then((res) => {
              if (res.data.code != 200) {
                this.$message("服务器繁忙");
                return;
              }
              this.$message("删除成功");
              this.getList();
            })
            .catch((res) => {
              this.$message("服务器繁忙");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    addAddr() {
      if (!this.very()) {
        return;
      }
      console.log(this.submitForm.id);
      if (this.submitForm.id) {
        this.submitForm.addressid = this.submitForm.id;
        this.submitForm.type = "U";
      } else {
        this.submitForm.type = "I";
      }

      let user = sessionStorage.getItem("Authorization");
      user = JSON.parse(user);
      // 新增
      this.submitForm.customerid = user.customerid;
      //   let username = uni.getStorageSync("userinformation").username; //手机号或者账号

      this.axios
        .post("customer/addOrUpdateAddress", this.submitForm, {
          headers: {
            token: user.token,
          },
        })
        .then((res) => {
          console.log(res);
          if (res.data.code != 200) {
            this.$message.info(res.data.message);
            return;
          }

          this.$message.info(this.submitForm.id ? "修改成功!" : "新增成功!");
          this.getList();
          this.dialogVisible = false;
          this.resetData();
        })
        .catch((res) => {
          console.log(res);
        });
    },
    getList() {
      let user = sessionStorage.getItem("Authorization");
      user = JSON.parse(user);

      this.axios
        .get("customer/addressList/" + user.customerid + "/T", {
          headers: {
            token: user.token,
          },
        })
        .then((res) => {
          console.log(res);
          this.addList = res.datas;
          if (res.data.code != 200) {
            this.$message.info("服务器繁忙...");
            return;
          }
          this.addrList = res.data.datas.map((item, index) => {
            return {
              id: item.id,
              name: item.name,
              tel: item.tel,
              isDefault: item.isdefault,
              country: item.parvince,
              city: item.city,
              area: item.area,
              address: item.address,
              tag: item.tag,
            };
          });
          console.log(this.addrList);
        })
        .catch((res) => {
          console.log("falss");
        });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    //   获取地址列表
    this.getList();
    // 获取目的国列表
    this.getPopList();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    // window.addEventListener("scroll",this.handleScroll);
  },
  destroyed() {
    //  window.removeEventListener('scroll', this.handleScroll)
  },
};
</script>
<style lang="scss" scoped >
.editBtn {
  border-right: 1px solid #e7e7e7;
  padding: 0 20px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: $d2d-color-primary;
}

.defaultAddrDiv {
  margin-left: 20px;
  display: inline-block;
  height: 26px;
  background: $d2d-color-primary-light;
  border: 1px solid $d2d-color-primary;
  border-radius: 5px;
  span {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: $d2d-color-primary;
    line-height: 26px;
    padding: 0 8px 0 8px;
  }
}
.btnBorder {
  width: 147px;
  height: 40px;
  background: #ffffff;
  margin: 30px 0 20px 0;
  border: 1px solid $d2d-color-primary;
  border-radius: 5px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  span {
    color: $d2d-color-primary;
  }
}
.card-hover:hover {
  border: 1px solid $d2d-color-primary;
}
.class1 {
  border-radius: 20px;
}
.pointer {
  cursor: pointer;
}
/* //@import url(); 引入公共css类 */
</style>


// WEBPACK FOOTER //
// src/components/PersonalCenter/personalInfo/PickPage.vue